import moment from 'moment';

export const urlPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

export const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatAccountNo = s => {
    return s.toString().replace(/\d{4}(?=.)/g, '$& ');
};

export const convertDateRange = range => {
    if (!range) {
        return {
            start: moment().format('L'),
            end: moment().format('L')
        };
    }

    const dates = range.match(/\d{2}\/\d{2}\/\d{4}/g);
    if (dates.length !== 2) {
        return {
            start: '',
            end: ''
        };
    }

    return {
        start: dates[0],
        end: dates[1]
    };
};

// export const accountLevelFromAccountType = (accountType) => {
//   let level = ''
//   if (accountType.startsWith('admin')) {
//     level = 'admin'
//   } else if (accountType.startsWith('company')) {
//     level = 'company'
//   }
//   return level
// }

export const formatTime = (date) => {
    return moment(date).format('ddd, MMM DD, H:mm:ss Z');
};

export const translateList = (t, list) => {
    return list.map(element => {
        return t(element);
    });
};

export const mapBootstrapClassToStatus = (status) => {
    if (status.includes('lock')) {
        return 'danger';
    }
    if (status.includes('suspend')) {
        return 'warning';
    }
    if (status.includes('active')) {
        return 'dark';
    }
    return 'primary';
};

export const customDateRangeDisplay = (t) => {
    const today = t('Today');
    const yesterday = t('Yesterday');
    const last7days = t('Last 7 Days');
    const last30days = t('Last 30 Days');
    const thisMonth = t('This Month');
    const lastMonth = t('Last Month');
    let obj = {};
    obj[today] = [moment(), moment()];
    obj[yesterday] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
    obj[last7days] = [moment().subtract(6, 'days'), moment()];
    obj[last30days] = [moment().subtract(29, 'days'), moment()];
    obj[thisMonth] = [moment().startOf('month'), moment().endOf('month')];
    obj[lastMonth] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
    return obj;
};

export const mapColorClassToStatus = (status) => {
    if (status.includes('lock') || status.includes('delete')) {
        return 'lock-button';
    }
    if (status.includes('suspend')) {
        return 'suspend-color';
    }
    if (status.includes('ban') || status === 'inactive') {
        return 'ban-button';
    }
    return 'primary';
};

export const mapBootstrapColorToStatus = (status) => {
    if (status.includes('cancel_success')) {
        return 'light';
    }

    if (status.includes('fail')) {
        return 'danger';
    }

    if (status.includes('success')) {
        return 'success';
    }
    return 'dark';
};

export const mapStatusToCodeLocalize = (status) => {
    if (status.includes('cancel_success')) {
        return 'canceled';
    }

    if (status.includes('success')) {
        return 'Success';
    }
    return status;
};

export const urlParams = new URLSearchParams(window.location.search);
